const initialState = "white";

const theme = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_THEME':
            state = action.payload.theme
            return state;

        default:
            return state;
    }
};

export default theme;